import { AgGridVue } from 'ag-grid-vue'
import gridMixin from '../mixins/gridMixin'
import CompanyMixin from '@/store/module/company/mixin'
import PermissionMixin from '@/store/module/permission/mixin'
import { loading, toast } from '@/shared/utils/UIHelper'
import WorkPositionRepository from '@/shared/http/repositories/business/workPosition'
import PDRWorkPositionReportRepository from '@/shared/http/repositories/pci/pdrworkpositionreport'

import moment from 'moment'

export default {
  name: 'ReportWorkPosition',
  components: {
    AgGridVue
  },
  mixins: [gridMixin, CompanyMixin, PermissionMixin],
  data () {
    return {
      // report grid
      onGridReport: null,
      reportRowData: [{}],
      reportColumnDefs: [
        {
          headerName: 'Início Apuração',
          field: 'inicio',
          minWidth: 150,
          valueGetter: (param) => {
            if (param.data.inicio) {
              return moment(param.data.inicio).startOf('day').toDate().toLocaleDateString()
            }
          }
        },
        {
          headerName: 'Término Apuração',
          field: 'termino',
          minWidth: 150,
          valueGetter: (param) => {
            if (param.data.termino) {
              return moment(param.data.termino).startOf('day').toDate().toLocaleDateString()
            }
          }
        },
        {
          headerName: 'Função',
          field: 'funcaoObra.nome',
          minWidth: 400
        },
        {
          headerName: 'Descrição',
          field: 'descricao',
          minWidth: 400
        }
      ],
      reportGridOptions: {
        groupHeaderHeight: 20,
        headerHeight: 20,
        rowHeight: 20
      },
      // work grid
      onGridWork: null,
      workRowData: [{}],
      workColumnDefs: [
        {
          headerName: 'Coordenador',
          field: 'nome',
          minWidth: 150
        }
      ],
      workGridOptions: {
        groupHeaderHeight: 20,
        headerHeight: 20,
        rowHeight: 20
      },
      // modal report form
      showReportFom: false,
      availableFunction: {
        options: []
      },
      reportForm: {
        inicio: null,
        termino: null,
        descricao: null,
        descricaoindicadores: null,
        naoconformidade: null,
        causas: null,
        acoespreventivacorretiva: null,
        responsaveis: null,
        observacao: null,
        funcaoobraid: null
      },
      printReportParams: {
        reportId: null,
        workerId: null
      }
    }
  },
  methods: {
    onLoad () {
      loading.push()
      this.getWorkPositionReports()
    },
    selectReport (params) {
      let workPositionId = params.node.data.funcaoObraID
      let startDate = params.node.data.inicio
      let endDate = params.node.data.termino
      if (params.node.isSelected()) {
        loading.push()
        this.printReportParams.reportId = params.node.data.id
        this.printReportParams.workerId = null
        PDRWorkPositionReportRepository.GetWorkCoordinators({workPositionId, startDate, endDate})
          .then(response => {
            const data = response.data.data
            this.workRowData = data
          })
          .catch(error => {
            console.log(error)
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .finally(() => {
            loading.close()
          })
      }
      console.log(this.printReportParams)
    },
    SelectCoordinator (params) {
      if (params.node.isSelected()) {
        this.printReportParams.workerId = params.node.data.id
      }
      console.log(this.printReportParams)
    },
    printAnaliticReport () {
      // this.printReportParams.reportId // esse é o parâmetro: PDRRelatorioFuncaoObraId
      // this.printReportParams.workerId // esse é o parâmetro: FuncionarioId
      // TODO. alterar o backend e a consulta no fastReport para filtrar pelo funcionarioId
      // tem que trazer os registros onde o funcionarioId é o coordenador da obra
      PDRWorkPositionReportRepository.GetReport(this.printReportParams.reportId)
        .then(response => {
          if (response.data.code > 0) {
            const binary = window.atob(response.data.data.replace(/\s/g, ''))
            const len = binary.length
            const buffer = new ArrayBuffer(len)
            const view = new Uint8Array(buffer)
            for (let i = 0; i < len; i++) {
              view[i] = binary.charCodeAt(i)
            }
            const blob = new Blob([view], {type: 'application/pdf'})

            const fileURL = URL.createObjectURL(blob)
            window.open(fileURL)
          }
        })
        .catch(error => {
          console.log(error)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    printGraphicReport () {
      alert('implementar relatorio gráfico')
      // this.printReportParams.reportId // esse é o parâmetro: PDRRelatorioFuncaoObraId
      // this.printReportParams.workerId // esse é o parâmetro: FuncionarioId
      // aqui deve chamar o endpoint que monta o relatório no fast report
    },
    getWorkPositionReports () {
      PDRWorkPositionReportRepository.GetAllReports()
        .then(response => {
          const data = response.data.data
          this.reportRowData = data
        })
        .catch(error => {
          console.log(error)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => {
          loading.close()
        })
    },
    onGridReportReady (params) {
      this.onGridReport = params.api
      params.api.expandAll()
      this.$nextTick(() => {
        params.api.sizeColumnsToFit()
      })
    },
    onGridWorkReady (params) {
      this.onGridWork = params.api
      params.api.expandAll()
      this.$nextTick(() => {
        params.api.sizeColumnsToFit()
      })
    },
    showReportModal () {
      this.showReportFom = true
      this.getWorkPosition()
    },
    sendReportForm () {
      let isValid = true
      isValid = isValid && this.formDateValidate(this.reportForm)
      isValid = isValid && this.formIdValidate(this.reportForm.funcaoobraid)
      if (isValid) {
        loading.push()
        PDRWorkPositionReportRepository.CreateReport(this.reportForm)
          .then(response => {
            toast.success('Relatório cadastrado com sucesso!')
            this.reportForm = {
              inicio: null,
              termino: null,
              descricao: null,
              descricaoindicadores: null,
              naoconformidade: null,
              causas: null,
              acoespreventivacorretiva: null,
              responsaveis: null,
              observacao: null,
              funcaoobraid: null
            }
            this.showReportFom = false
            this.getWorkPositionReports()
          })
          .catch(error => {
            console.log(error)
            toast.error(this.$lang.Common.Alerts.Error)
            loading.close()
          })
          .finally(() => {
            // loading.close()
          })
      }
    },
    formDateValidate (form) {
      if (form.inicio && form.termino) {
        let start = Date.parse(form.inicio)
        let end = Date.parse(form.termino)
        if (start > end) {
          toast.error('Data de início não pode ser maior que a data de termino')
          return false
        }
      }
      return true
    },
    formIdValidate (id) {
      if (!id) {
        toast.error('Função é obrigatório')
        return false
      }
      if (!(/^[0-f]{8}-[0-f]{4}-[0-f]{4}-[0-f]{4}-[0-f]{12}$/).test(id)) {
        toast.error('Função é inválida')
        return false
      }
      return true
    },
    getWorkPosition () {
      if (this.availableFunction.options.length === 0) {
        loading.push()
        WorkPositionRepository.GetAll()
          .then(response => {
            response.data.data.forEach(e => {
              const option = {value: e.id, text: e.nome}
              this.availableFunction.options.push(option)
            })
          })
          .catch(error => {
            console.log(error)
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .finally(() => {
            loading.close()
          })
      }
    }
  },
  beforeMount () {
    this.onLoad()
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/reportWorkPosition/reportWorkPosition.js